import api from '../../api'

type UploadResultError = {
  propertyName: string | null | undefined
  value: any
  message: string
}

export type UploadResult = {
  success: boolean
  total: number
  errors: UploadResultError[]
  duplicates: UploadResultError[]
}

export const downloadCsv = async (url: string, post: boolean = false): Promise<any> => {
  const API_ENDPOINT = (window as any).env.API_ENDPOINT
  const fullUrl = `${API_ENDPOINT}/${url.replace(/^\/+/, '')}`
  const response = post ?
    await api.post(fullUrl) :
    await api.get(fullUrl)
  return response.data
}

export const uploadCsv = async (file: File, url: string): Promise<UploadResult> => {
  const formData = new FormData()
  formData.append('import_file', file)
  
  const response = await api.post<UploadResult>(url, formData)
  return response.data
}